import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GreyhoundRacingIcon = observer('GreyhoundRacingIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M14.2892 6.62195C13.2668 6.46299 12.7468 6.44714 11.9598 6.62195C10.8589 6.90511 9.83532 7.05519 8.82731 7.07896C7.02837 7.46689 5.93258 7.9913 5.04564 8.58537C4.14045 8.80787 3.15296 9.01061 2 9.18293V14.2195C5.36227 16.1631 7.12508 16.3869 9.95181 14.561L9.95795 14.6105C10.0869 15.6505 10.161 16.2486 10.5141 16.2683C12.7752 15.7911 13.8649 15.6317 15.4137 15.5854C16.7562 15.817 17.266 16.0925 17.4217 17.0366C17.1563 17.4692 17.1245 17.7122 17.1807 18.1463C17.7829 18.7635 18.0852 18.8482 18.6215 18.9986L18.6265 19C19.0218 16.8876 18.3306 15.871 16.2169 14.2195C16.8335 14.1483 17.182 14.1008 17.8233 13.9634C18.495 14.0635 18.8838 14.2056 19.5904 14.561L20.1526 15.4146C21.207 15.5034 21.6059 15.4373 22 15.0732C20.6973 14.1697 19.4644 13.6371 17.1807 12.6829C14.8852 12.906 13.8001 12.982 12.6024 12.939C13.1403 12.174 13.2388 11.5686 13.0843 10.2073L16.0562 9.0122C16.6829 9.43404 17.3735 9.69329 19.3494 10.2073C20.0818 10.1912 20.5005 10.1927 20.8755 9.69512C21.196 9.70632 21.3601 9.65187 21.5984 9.35366C20.2289 8.77693 19.8538 8.46142 19.3494 7.90244C18.6979 6.06495 17.9 5.74198 16.0562 5.85366C15.7415 5.42896 15.3213 5.26994 14.5301 5C13.3897 5.19446 13.0505 5.41107 12.6024 5.85366C13.5641 6.08836 13.961 6.25045 14.2892 6.62195Z'
                fill='fill'
            />
        </SvgElement>
    );
});
